import { RefString, Select, Button } from "@tblabs/truffle";
import { Row } from "../Components/Row";


export class StorableSelect extends Row
{
    constructor(value: RefString, storableAs: string)
    {
        const valueFromStorage = JSON.parse(window.localStorage.getItem(storableAs) || "[]") as string[];
        const select = new Select(value, valueFromStorage).Style("flex: 1").Class("white");

        super(
            select,
            new Button("+").PaddingLeft(12).PaddingRight(12).OnClick(() =>
            {
                const v = prompt("Enter value");
                if (v)
                {
                    valueFromStorage.push(v);
                    select.LoadOptions(valueFromStorage);
                    window.localStorage.setItem(storableAs, JSON.stringify(valueFromStorage));
                    value.value = v;
                }
            }),
            new Button("-").PaddingLeft(14).PaddingRight(14).OnClick(() =>
            {
                valueFromStorage.splice(valueFromStorage.indexOf(value.value), 1);
                select.LoadOptions(valueFromStorage);
                window.localStorage.setItem(storableAs, JSON.stringify(valueFromStorage));
                value.value = valueFromStorage[0];
            })
        );
    }
}
